import { FilePondFile } from 'filepond';
import { FilePond } from 'react-filepond';
import { File } from 'src/components/moleculesLegacy/FileUpload';
import { MCCEventType, UploadScanStatus } from 'src/types';

interface EventFileData {
  id: string;
  created: string;
  updated: string;
  path: string;
  status: UploadScanStatus | null;
}

export const updateFiles = async (
  pond: FilePond,
  setChangedFiles: (files: File[]) => void,
  updateCurrentEvent: (
    event: MCCEventType,
    key?: string | undefined,
    value?: EventFileData[],
  ) => Promise<unknown>,
  currentEvent: MCCEventType,
) => {
  const timestamp = new Date().toISOString();
  const newFiles = pond
    .getFiles()
    .map((x: FilePondFile & { created?: string }) => ({
      source: x.serverId.replaceAll('"', ''),
      options: {
        type: 'local' as const,
        file: {
          name: x.filename,
          size: x.fileSize,
          type: x.fileType,
        },
        metadata: {
          scanStatus: x.getMetadata('scanStatus') || UploadScanStatus.PENDING,
        },
      },
      status: x.status,
      created: x.created ?? timestamp,
      updated: timestamp,
    }))
    .filter((x) => x.source !== null);

  setChangedFiles(newFiles);

  await updateCurrentEvent(
    currentEvent,
    'files',
    newFiles.map((file) => ({
      id: file.source,
      created: file.created,
      updated: file.updated,
      path: `${file.source}.${file.options.file.name.split('.').pop()}`,
      status:
        (file.options.metadata?.scanStatus as UploadScanStatus) ||
        UploadScanStatus.PENDING,
    })),
  );
};
